export enum RuleInstructionKind {
  ADD_RULE = 'addRule',
  ADD_RULE_WITH_MEASURED_ROLLOUT_V2 = 'addRuleWithMeasuredRolloutV2',
  REMOVE_RULE = 'removeRule',
  REORDER_RULES = 'reorderRules',
  REPLACE_RULES = 'replaceRules',
  UPDATE_RULE_VARIATION_OR_ROLLOUT = 'updateRuleVariationOrRollout',
  UPDATE_RULE_WITH_MEASURED_ROLLOUT_V2 = 'updateRuleWithMeasuredRolloutV2',
  UPDATE_RULE_DESCRIPTION = 'updateRuleDescription',
  DISABLE_RULE = 'disableRule',
  ENABLE_RULE = 'enableRule',
  STOP_MEASURED_ROLLOUT_ON_RULE = 'stopMeasuredRolloutOnRule',
  START_AUTOMATED_RELEASE = 'startAutomatedRelease',
}
